import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/imgcaptions/icon_gongjulan_16.png'
import _imports_1 from '@/assets/imgcaptions/icon_tianjiasel.png'


const _hoisted_1 = { class: "findReplaceBoxInner" }
const _hoisted_2 = { class: "findReplaceMain" }
const _hoisted_3 = { class: "rowMain" }
const _hoisted_4 = { class: "typeMain" }
const _hoisted_5 = { class: "rowMain" }
const _hoisted_6 = { class: "rowMainInput" }
const _hoisted_7 = { class: "rowMain" }
const _hoisted_8 = { class: "rowMainSearch" }
const _hoisted_9 = { class: "rowSearchReplace" }
const _hoisted_10 = { class: "rowSearchCenter" }
const _hoisted_11 = { class: "rowNumCenter" }
const _hoisted_12 = { class: "rowCenter" }
const _hoisted_13 = { class: "rowMain" }
const _hoisted_14 = { class: "rowMainInput" }
const _hoisted_15 = { class: "rowMain" }
const _hoisted_16 = { class: "btnStyle" }

import {
    Close,
} from "@element-plus/icons-vue";
import { ref, onMounted,watch,reactive,nextTick } from 'vue'
// 引入接口
import newCaptionApi from "@/api/newCaption/index.ts";
import { uuid } from '@/components/public-method/getuuid';

export default /*@__PURE__*/_defineComponent({
  __name: 'findReplace',
  props: {
    list:Array,
    textId:String,
    deltranslatShow:Boolean,
    },
  emits: ['closeThis','findReplaceFun','replaceWord','showTxtThis','filterListFun'],
  setup(__props, { emit: __emit }) {

const emit = __emit
const props = __props
const  textList=ref([])
const selColor={
    'color':'red'
}
const canClickStyle={
    'background': 'rgba(32, 124, 246, 0.9)'
}
const dontClickStyle={
    'background': 'rgba(238, 251, 255, 0.25)'
}
const language = ref('cn')
const langStyle = {
    'background': 'rgba(238, 251, 255, 0.25)'
}
watch(props,(n,o)=>{
    textList.value=JSON.parse(JSON.stringify(props.list))
})
onMounted(()=>{
    textList.value=JSON.parse(JSON.stringify(props.list))
})
const onOff=ref(false)//查询数量后才能进行后续操作
const filterReplace=ref(false)//是否显示匹配字幕
const filterReplaceFun=(data:boolean)=>{
    filterReplace.value=data
    if(findTxt.value=='') return
    emit('filterListFun',[data,findTxt.value,language.value])
    
}
// 切换
const oneType=ref('originalTextReplace')
const oneTypeTxt=ref('original')
const selType=(type:string)=>{
    language.value=type
    onOff.value=false
    if(type=='cn'){
        oneType.value='originalTextReplace'
        oneTypeTxt.value='original'
    }else{
        oneType.value='translationTextReplace'
        oneTypeTxt.value='translation'
    }
}
// 拖拽移动
const findRef=ref()
const startPos = reactive({ x: 0, y: 0 })
const boxDown=(e:any)=>{
    let boxStyle=findRef.value.getBoundingClientRect()
    startPos.x=e.clientX -boxStyle.left
    startPos.y=e.clientY -boxStyle.top
    document.addEventListener('mousemove', boxdrag);
    document.addEventListener('mouseup', boxStopdrag);
}
const boxdrag=(e:any)=>{
    if (!findRef.value) return
    findRef.value.style.left = (e.clientX - startPos.x)+'px'
    findRef.value.style.top= (e.clientY - startPos.y)+'px'
}
const boxStopdrag=()=>{
    
    document.removeEventListener('mousemove', boxdrag)
}

const findTxt=ref('')//查找内容
const findTxtRecord=ref('')//记录查找内容
const replacetxt=ref('')//替换内容
const showNum=ref(0)//查找到相关内容计数
const indexFindList=ref([])//查找到数量容器
const indexFind=ref(0)//查找到数据位置

// 查询字段出现个数
const searchNum=()=>{
    if(findTxt.value=='') return
    onOff.value=true
    indexFind.value=0
    indexFindList.value=[]
    showNum.value=0
    findTxtRecord.value=JSON.parse(JSON.stringify(findTxt.value))
    textList.value.forEach(item=>{
        // item.original.text
        let str=item[oneTypeTxt.value].text
        if(str.indexOf(findTxtRecord.value)!=-1){
            
           let num= str.split(findTxtRecord.value).length - 1
           for(let i=0;i<num;i++){
            indexFindList.value.push(item.id)
           }
           showNum.value+=num
           emit('showTxtThis',JSON.stringify(indexFindList.value[0]))
        }
    })
}
// 显示匹配数据
const showMatchList=()=>{
    textList.value=JSON.parse(JSON.stringify(props.list.filter(item=>item.original.text.indexOf(findTxt.value)!=-1)))
}
// 查找上一条
const findUp=()=>{
    console.log('查找上一条')
    console.log(indexFindList.value)
    if(!onOff.value) return
    if(indexFind.value>0) {
        indexFind.value--
    }else{
        return
    }
    emit('showTxtThis',JSON.stringify(indexFindList.value[indexFind.value]))
    
    let txt=textList.value.filter(item=>item.id==indexFindList.value[indexFind.value])[0]
    
}
// 查找下一条
const findDown=()=>{
    console.log('查找下一条')
    console.log(indexFindList.value)
    console.log(indexFind.value)
    if(!onOff.value) return
    if(indexFind.value<indexFindList.value.length-1) {
        indexFind.value++
    }else{
        return
    }
    emit('showTxtThis',JSON.stringify(indexFindList.value[indexFind.value]))
    let txt=textList.value.filter(item=>item.id==indexFindList.value[indexFind.value])[0]
   
}
// 替换
const toReplace=()=>{
    console.log('替换'+props.textId)
    if(!onOff.value) return
    // textList.value.filter(item=>item.id==indexFindList.value[indexFind.value])[0].original.text
    let oldData=JSON.parse(JSON.stringify(textList.value.filter(item=>item.id==indexFindList.value[indexFind.value])[0]) )
   let str= textList.value.filter(item=>item.id==indexFindList.value[indexFind.value])[0][oneTypeTxt.value].text
   let index=textList.value.findIndex(item=>item.id==indexFindList.value[indexFind.value])
   console.log(indexFind.value)
   console.log(indexFindList.value)
   console.log(str)
   let firstIndex=indexFindList.value.findIndex(item=>item==indexFindList.value[indexFind.value])
   let intervalNum=(indexFind.value-firstIndex)
   let tostr=replaceNthOccurrence(str, findTxtRecord.value, replacetxt.value, (intervalNum+1))
   textList.value.filter(item=>item.id==indexFindList.value[indexFind.value])[0][oneTypeTxt.value].text=tostr
   let newData=JSON.parse(JSON.stringify(textList.value.filter(item=>item.id==indexFindList.value[indexFind.value])[0]) )
   console.log(tostr)
    //  记录撤销还原数据
    let objChange={
        index: index,
        old: oldData,
        new: newData,
        type: 'toReplace'+oneTypeTxt.value
    }  
   let obj={
    text:tostr,
    originalText:findTxt.value,
    replaceText:replacetxt.value,
   }
   console.log(objChange)
   newCaptionApi.putEditCaption(props.textId, obj, indexFindList.value[indexFind.value], (index+1), oneType.value).then(res => {
        if (res.code == 200) {
            emit('replaceWord',JSON.stringify(objChange))
            emit('closeThis')
        }
    })

}
// 全部替换
const uuids=ref(uuid().replaceAll("-", ""))
const alltoReplace=()=>{
    console.log('全部替换')
    if(!onOff.value) return
    let obj
    let objOld
    let objArr=[]
    const oldTodata=JSON.parse(JSON.stringify(textList.value))
    let objChange={
        index: 0,
        old: [],
        new: [],
        type: 'ListReplace'+oneTypeTxt.value
    } 
    let olduuId=uuid().replaceAll("-", "")
    textList.value.forEach((item,index)=>{
        // item.original.text
        let str=item[oneTypeTxt.value].text
        if(str.indexOf(findTxtRecord.value)!=-1){
            obj={
                batch:uuids.value,
                data: {
                    text:item[oneTypeTxt.value].text.replaceAll(findTxt.value, replacetxt.value),
                    originalText:findTxt.value,
                    replaceText:replacetxt.value,
                },
                id: item.id,
                line: index+1,
                type: oneType.value,
            }
            objOld={
                batch:olduuId,
                data: {
                    text:oldTodata[index][oneTypeTxt.value].text,
                    originalText:replacetxt.value,
                    replaceText: findTxt.value,
                },
                id: item.id,
                line: index+1,
                type: oneType.value,
            }
            objArr.push(obj)
            objChange.new.push(obj)
            objChange.old.push(objOld)
            item[oneTypeTxt.value].text=item[oneTypeTxt.value].text.replaceAll(findTxt.value, replacetxt.value)
           
        }
    })
   
   
    nextTick(()=>{
        newCaptionApi.putEditbatchCaption(props.textId, objArr).then(res=>{
            console.log(res)
            uuids.value=uuid().replaceAll("-", "")
            emit('replaceWord',JSON.stringify(objChange))
            emit('closeThis')
        })
    })
   
}
function replaceNthOccurrence(str, search, replace, n) {
  const parts = str.split(search);
  if (parts.length <= n) return str;
  
  let result = '';
  for (let i = 0; i < parts.length; i++) {
    if (i > 0) {
      result += (i === n) ? replace : search;
    }
    result += parts[i];
  }
  
  return result;
}

// 关闭弹窗
const closeBox=()=>{
    emit('closeThis')
}


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "findReplaceBox",
    onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"])),
    ref_key: "findRef",
    ref: findRef
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "findReplaceTitle",
        onMousedown: _cache[0] || (_cache[0] = ($event: any) => (boxDown($event)))
      }, [
        _cache[8] || (_cache[8] = _createElementVNode("span", null, "查找/替换", -1)),
        _createElementVNode("span", {
          class: "closeBtn",
          onClick: _withModifiers(closeBox, ["stop"])
        }, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(Close))
            ]),
            _: 1
          })
        ])
      ], 32),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "rowMainTitle" }, " 字幕类型 ", -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", {
              style: _normalizeStyle(language.value == 'cn' ? langStyle : ''),
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ( selType('cn')), ["stop"]))
            }, "原文", 4),
            (__props.deltranslatShow)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  style: _normalizeStyle(language.value == 'en' ? langStyle : ''),
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (selType('en')), ["stop"]))
                }, "译文", 4))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "rowMainTitle" }, "查找内容", -1)),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "请输入内容",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((findTxt).value = $event))
            }, null, 512), [
              [_vModelText, findTxt.value]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "rowMainTitle" }, null, -1)),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: "rowSearchBtn",
              onClick: _withModifiers(searchNum, ["stop"])
            }, " 搜索 "),
            _withDirectives(_createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("img", {
                src: _imports_0,
                alt: "",
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (filterReplaceFun(true)), ["stop"]))
              }, null, 512), [
                [_vShow, !filterReplace.value]
              ]),
              _withDirectives(_createElementVNode("img", {
                src: _imports_1,
                alt: "",
                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (filterReplaceFun(false)), ["stop"]))
              }, null, 512), [
                [_vShow, filterReplace.value]
              ]),
              _cache[11] || (_cache[11] = _createElementVNode("span", null, "只显示匹配字幕", -1))
            ], 512), [
              [_vShow, onOff.value]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, "共搜索到 " + _toDisplayString(showNum.value) + " 条匹配字幕", 1),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", {
              onClick: _withModifiers(findUp, ["stop"]),
              style: _normalizeStyle(onOff.value?canClickStyle:dontClickStyle)
            }, "上一条", 4),
            _createElementVNode("span", {
              onClick: _withModifiers(findDown, ["stop"]),
              style: _normalizeStyle(onOff.value?canClickStyle:dontClickStyle)
            }, "下一条", 4)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "rowMainTitle" }, "替换为", -1)),
          _createElementVNode("div", _hoisted_14, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "请输入内容",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((replacetxt).value = $event))
            }, null, 512), [
              [_vModelText, replacetxt.value]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "rowMainTitle" }, null, -1)),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("span", {
              onClick: _withModifiers(toReplace, ["stop"]),
              style: _normalizeStyle(onOff.value?canClickStyle:dontClickStyle)
            }, "替换", 4),
            _createElementVNode("span", {
              onClick: _withModifiers(alltoReplace, ["stop"]),
              style: _normalizeStyle(onOff.value?canClickStyle:dontClickStyle)
            }, "全部替换", 4)
          ])
        ])
      ])
    ])
  ], 512))
}
}

})